import { useQuery } from "react-query";

import useWidgetUUID from "hooks/useWidgetUUID";
import { useAPI } from "libs/api";
import Widget from "models/Widget";

import useQueryKey from "./useQueryKey";

const useWidgetQuery = (options = {}, widgetUUID = null) => {
  const api = useAPI("WeezPay");
  const defaultWidgetUUID = useWidgetUUID();
  const finalWidgetUUID = widgetUUID || defaultWidgetUUID;

  const queryKey = useQueryKey([]);

  return useQuery(
    queryKey,
    () => api.widgets.get(finalWidgetUUID),
    {
      cacheTime: Infinity,
      staleTime: 10000,
      enabled: !!api && !!finalWidgetUUID,
      select: (data) => Widget.fromAPI(data),
      refetchOnMount: false,
      ...options,
    },
  );
};

export default useWidgetQuery;
